// UTM capture, persistence, and analytics context helpers.

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;
const STORAGE_KEY = 'verdeia_utm';

export type UtmParams = Partial<Record<(typeof UTM_KEYS)[number], string>>;

export function captureUtmFromLocation(): UtmParams {
  if (typeof window === 'undefined') return {};
  try {
    const params = new URLSearchParams(window.location.search);
    const captured: UtmParams = {};
    UTM_KEYS.forEach((key) => {
      const v = params.get(key);
      if (v) captured[key] = v.slice(0, 120);
    });
    if (Object.keys(captured).length > 0) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
      return captured;
    }
    return getStoredUtm();
  } catch {
    return {};
  }
}

export function getStoredUtm(): UtmParams {
  if (typeof window === 'undefined') return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as UtmParams) : {};
  } catch {
    return {};
  }
}

export function getAnalyticsContext(): Record<string, unknown> {
  if (typeof window === 'undefined') return {};
  const width = window.innerWidth;
  let bucket = 'desktop';
  if (width < 380) bucket = 'mobile_xs';
  else if (width < 430) bucket = 'mobile_sm';
  else if (width < 768) bucket = 'mobile_lg';
  else if (width < 1024) bucket = 'tablet';
  return {
    ...getStoredUtm(),
    device: width < 768 ? 'mobile' : 'desktop',
    viewport_bucket: bucket,
    referrer: document.referrer || 'direct',
  };
}
